import React from 'react';

import ErrorIcon from '@nerdwallet/react-icon/material/Error';
import { colors } from '@nerdwallet/base-styles/variables';
import AutoRenewIcon from '@nerdwallet/react-icon/material/Autorenew';

import styles from './status-indicator.module.scss';

export enum Status {
  ERROR = 'error',
  REFRESHING = 'refreshing',
}

/**
 * Adds a small badge to a child component indicating its status (e.g. error or refreshing).
 */
const StatusIndicator: React.FC<InstitutionStatusIndicatorProps> = ({
  children,
  status,
}) => {
  return (
    <div className={styles.container}>
      {children}
      {status === Status.ERROR && (
        <div className={styles.errorIndicator}>
          <ErrorIcon color={colors.yellow} size={16} />
        </div>
      )}
      {status === Status.REFRESHING && (
        <div className={styles.refreshingIndicator}>
          <AutoRenewIcon color={colors.white} size={12} />
        </div>
      )}
    </div>
  );
};

interface InstitutionStatusIndicatorProps {
  children: React.ReactNode; // Typically another icon component
  status?: Status;
}

export default StatusIndicator;
